import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse, Row, Col, Form } from 'antd';
import { StyleUtils } from '../../misc';
import { BasicNodeModel } from '../../models';
import { LayoutRendererProps } from '../../componentTypes';
import { CollapseExpandIcon } from '../../../custom_shared/components';
import './BasicLayoutRenderer.less';

interface Props extends LayoutRendererProps {
    node: BasicNodeModel;
}

const BasicLayoutRenderer: React.FC<Props> = (props: Props) => {
    const { node, formKey, form, onValuesChange, getComponentRows } = props;

    const rows = React.useMemo(
        () => getComponentRows(node.inputs, { NodeId: node.id }),
        [node.inputs, node.id, getComponentRows]
    );

    return (
        <div className="basic-layout-renderer-container custom-scroll">
            <Form id={node.id} key={formKey} form={form} onValuesChange={onValuesChange}>
                <div className="basic-collapse-panel-container">
                    <Collapse
                        activeKey={node.expanded ? [node.id] : []}
                        onChange={node.toggleExpanded}
                        bordered={false}
                        expandIcon={CollapseExpandIcon}
                    >
                        <Collapse.Panel
                            className="basic-collapse-panel"
                            header={<span className="header-title">{node.name}</span>}
                            key={node.id}
                        >
                            {rows.map((componentRow, index) => (
                                <Row key={index} gutter={10}>
                                    {componentRow.map(({ component, columnSpan }) => (
                                        <Col key={component.key} style={StyleUtils.getNodeColumnStyle(columnSpan ?? 8)}>
                                            {component}
                                        </Col>
                                    ))}
                                </Row>
                            ))}
                        </Collapse.Panel>
                    </Collapse>
                </div>
            </Form>
        </div>
    );
};

export default observer(BasicLayoutRenderer);
